export default __webpack_public_path__ + "static/one-stop-shop-89082088ea11adb71dae50f69a05c660.png";